module.exports = __webpack_public_path__ + "static/media/za.97ae15ae.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/za.svg
// module id = 2246
// module chunks = 0